import useSWR from 'swr'
import { LibraryCollectionKpis, LibraryKpiWindow } from '@digital-twins/shared-types'

import { libraryCollectionsApi } from '@/lib/api'

import { LIBRARY_COLLECTION_KPIS_SWR_KEY } from './useLibraryCollection'

export interface UseCollectionKpisResult {
  kpis: LibraryCollectionKpis | null
  isLoading: boolean
  hasError: boolean
  refresh: () => Promise<unknown>
}

/**
 * The collection's four callouts over
 * `GET /library/collections/:token/kpis?window=`, keyed by token and window.
 * The previous window's callouts stay on screen while a new window loads.
 */
export function useCollectionKpis(
  token: string | null,
  window: LibraryKpiWindow,
): UseCollectionKpisResult {
  const { data, error, isLoading, mutate } = useSWR<LibraryCollectionKpis>(
    token ? [LIBRARY_COLLECTION_KPIS_SWR_KEY, token, window] : null,
    () => libraryCollectionsApi.getKpis(token as string, window),
    { revalidateOnFocus: false, keepPreviousData: true, shouldRetryOnError: false },
  )
  return {
    kpis: data ?? null,
    isLoading: Boolean(token) && isLoading,
    hasError: Boolean(error),
    refresh: () => mutate(),
  }
}
